const emptyStarterTimeTable = [
  {
    sl0: "Monday",
    sl1: ["", "", ""],
    sl2: ["", "", ""],
    sl3: ["", "", ""],
    sl4: ["", "", ""],
    sl5: ["", "", ""],
    sl6: ["", "", ""],
    sl7: ["", "", ""],
    sl8: ["", "", ""],
    sl9: ["", "", ""],
    sl10: ["", "", ""],
  },
  {
    sl0: "Tuesday",
    sl1: ["", "", ""],
    sl2: ["", "", ""],
    sl3: ["", "", ""],
    sl4: ["", "", ""],
    sl5: ["", "", ""],
    sl6: ["", "", ""],
    sl7: ["", "", ""],
    sl8: ["", "", ""],
    sl9: ["", "", ""],
    sl10: ["", "", ""],
  },
  {
    sl0: "Wednesday",
    sl1: ["", "", ""],
    sl2: ["", "", ""],
    sl3: ["", "", ""],
    sl4: ["", "", ""],
    sl5: ["", "", ""],
    sl6: ["", "", ""],
    sl7: ["", "", ""],
    sl8: ["", "", ""],
    sl9: ["", "", ""],
    sl10: ["", "", ""],
  },
  {
    sl0: "Thursday",
    sl1: ["", "", ""],
    sl2: ["", "", ""],
    sl3: ["", "", ""],
    sl4: ["", "", ""],
    sl5: ["", "", ""],
    sl6: ["", "", ""],
    sl7: ["", "", ""],
    sl8: ["", "", ""],
    sl9: ["", "", ""],
    sl10: ["", "", ""],
  },
  {
    sl0: "Friday",
    sl1: ["", "", ""],
    sl2: ["", "", ""],
    sl3: ["", "", ""],
    sl4: ["", "", ""],
    sl5: ["", "", ""],
    sl6: ["", "", ""],
    sl7: ["", "", ""],
    sl8: ["", "", ""],
    sl9: ["", "", ""],
    sl10: ["", "", ""],
  },
  {
    sl0: "Saturday",
    sl1: ["", "", ""],
    sl2: ["", "", ""],
    sl3: ["", "", ""],
    sl4: ["", "", ""],
    sl5: ["", "", ""],
    sl6: ["", "", ""],
    sl7: ["", "", ""],
    sl8: ["", "", ""],
    sl9: ["", "", ""],
    sl10: ["", "", ""],
  },
];

export { emptyStarterTimeTable };



// WEBPACK FOOTER //
// ./src/constants.js